import { useSelector } from "react-redux"
import { getOptimizeDate } from "modules/optimization/selectors"
import { createDateAdapter } from "./create-date-adapter"

export const withOptimizeDates = createDateAdapter(() => {
  const optimizeDate = useSelector(getOptimizeDate)
  return { startDate: optimizeDate, endDate: optimizeDate }
})
